import { api } from "@/auth/api";
import { settings } from "@/settings";

const EFLOROUTER_BASE = `${settings.api_url}/odm-eflorouter/router-api/1/order/create/`;

export interface VOCommandeResponse {
  statusMessageOrcabox: string;
  user_id: string;
  statusCodeOrcabox: number;
  error: boolean;
  urlDealerUi: string;
  fgId: string;
}

export const createFileCommande = async (payload: any): Promise<VOCommandeResponse> => {
  const response = await api().post(EFLOROUTER_BASE, payload);
  console.log(response);
  return response.data;
};

const CREDIPAR_CONTRACT_URL = `${settings.api_url}/odm-eflorouter/router-api/1/external/credipar/contract`;

export interface CrediparContractPayload {
  contractRef: string;
  affaireId: string;
  orderId?: string;
}

export const syncCrediparContract = async (
  payload: CrediparContractPayload
): Promise<any> => {
  const response = await api().post(CREDIPAR_CONTRACT_URL, payload);
  return response.data;
};
